<template>
  <transition name="fade">
    <div
      class="position-fixed start-0 bottom-0 bg-transparent z-1"
      v-show="showArrowHeight != 0 && scY > showArrowHeight"
    >
      <iconify-icon
        @click="toTop"
        class="m-2 p-2 border border-2 round border-secondary text-secondary bg-white xxl"
        icon="fa6-solid:chevron-up"
      />
    </div>
  </transition>
</template>

<script lang="ts">
import { settingsComputed } from "@/state/helpers";
import { defineComponent } from "vue";

export default defineComponent({
  name: "BackToTop",
  data() {
    return {
      scTimer: 0,
      scY: 0,
      showArrowHeight: 300,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.setArrowHeight();
  },
  computed: {
    ...settingsComputed,
  },
  methods: {
    handleScroll(): void {
      if (this.scTimer) return;
      this.scTimer = window.setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 100);
    },
    toTop(): void {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    setArrowHeight(): void {
      this.showArrowHeight = window.innerHeight;
    },
  },
  watch: {
    windowHeight() {
      this.setArrowHeight();
    },
  },
});
</script>

<style lang="css" scoped>
iconify-icon {
  width: 48px;
  height: 48px;
}
</style>
